import { useSnackbar } from 'notistack';

let snackbarRef;
export const SnackbarUtilsConfigurator = () => {
  snackbarRef = useSnackbar();
  return null;
};

const SnackbarUtils = {
  success(msg, options = {}) {
    this.toast(msg, { ...options, variant: 'success' });
  },
  warning(msg, options = {}) {
    this.toast(msg, { ...options, variant: 'warning' });
  },
  info(msg, options = {}) {
    this.toast(msg, { ...options, variant: 'info' });
  },
  error(msg, options = {}) {
    this.toast(msg, { ...options, variant: 'error' });
  },
  toast(msg, options = {}) {
    if (snackbarRef) {
      snackbarRef.enqueueSnackbar(msg, options);
    } else {
      console.error('Snackbar reference is not available');
    }
  },
};

export default SnackbarUtils;